import { render, staticRenderFns } from "./blog-10.vue?vue&type=template&id=34c7b5ff&scoped=true"
import script from "./blog-10.vue?vue&type=script&lang=js"
export * from "./blog-10.vue?vue&type=script&lang=js"
import style0 from "./blog-10.vue?vue&type=style&index=0&id=34c7b5ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c7b5ff",
  null
  
)

export default component.exports